import { AfterViewInit, Component, OnInit, SimpleChanges } from '@angular/core';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { MaestrasService } from 'src/app/service/maestras/maestras.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import {MenuResponse} from 'src/app/modal/maestras/menu-response';
import { NavigationEnd, Router } from '@angular/router';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
// daet 
import { DetalleOrdenComponent } from 'src/app/pagina-admin/dashboard/bandeja-pedido/detalle-orden/detalle-orden.component';
import {ViewChild,ElementRef} from '@angular/core';
import { MDBModalRef, MDBModalService, ModalDirective } from 'angular-bootstrap-md';
import { ModalHomeComponent } from 'src/app/modal-home/modal-home.component';
import { ToastrService } from 'ngx-toastr';

// nlpr ini
import { ChangeDetectionStrategy} from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
// nlpr fin

@Component({
  selector: 'app-header-detail',
  templateUrl: './header-detail.component.html',
  styleUrls: ['./header-detail.component.scss'],
  // nlpr ini
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [DatePipe],
  // nlpr fin
})
//daet ini
export class HeaderDetailComponent implements OnInit, AfterViewInit{
//export class HeaderComponent implements OnInit{
//daet fin

  // Mapeos para URLs amigables
  private CAT_ID_TO_SLUG: Record<string, string> = {
    '1': 'fotografias',
    '2': 'portadas',
    '3': 'consultas',
  };

  private SUB_ID_TO_SLUG: Record<string, Record<string, string>> = {
    '1': {
      // FOTOGRAFÍAS
      '1': 'cultura',
      '2': 'politica',
      '3': 'deportes',
      '4': 'espectaculos',
      '11': 'regiones',
      '12': 'economia',
      '13': 'sociedad',
      '14': 'presidentes',
    },
    '2': {
      // PORTADAS
      '5': 'siglo-xix',
      '6': 'siglo-xx',
      '7': 'siglo-xxi',
    },
    '3': {
      // CONSULTAS (si las hubiera)
    },
  };

  @ViewChild('myModal', {static : true}) myModal:ElementRef;

  @ViewChild(ModalDirective) modallogin: ModalDirective;

  // daet ini
  modalRefCambioEstado: MDBModalRef;
  // daet fin

  // nlpr ini
  @ViewChild(MatDateRangePicker) picker!: MatDateRangePicker<any>;
  isCollapsed = true; // El menú comienza colapsado
  selectedOption: string = '';
  isMenuCollapsed = true;
  isCulturalMenuOpen = false;
  isPortadasMenuOpen = false;
  //startDateValue: Date | null = null;
  //endDateValue: Date | null = null;
  //startDate: Date | null = null;
  //endDate: Date | null = null;
  //selectedDateRange: { startDate: Date, endDate: Date } = { startDate: null, endDate: null };  
  //selectedDate: any = { start: null, end: null };
  minDate = new Date(1960, 0, 1);  // Año 1900
  maxDate = new Date(2025, 11, 31); // Año 2100
  readonly startDate = new Date(1970, 0, 1);
  // nlpr fin

  // daet ini
  @ViewChild('txtFechaIni') refFecIni:ElementRef;
  @ViewChild('txtFechaFin') refFecFin:ElementRef;
  txtFechaIni:string="";
  txtFechaFin:string="";
  fechaIniLoad:string="";
  fechaFinLoad:string="";
  isFechaEnable:boolean;
  // daet fin
  flagActualizar=1;
  cantidadCarrito:number;
  cantidadCarritoAnterior:number = 0;
  menuFlag=false;
  menuResponse:MenuResponse;
  CatalogoDigital:boolean=true;
  txtBusqueda=this.utilitarioService.busqueda;
  constructor(private router: Router,private carritoService:CarritoService,
    private usuarioService:UsuarioService,private maestraService:MaestrasService,private novedadesService:NovedadesService,
    // daet ini
    private modalService: MDBModalService,
    // daet fin
    public utilitarioService:UtilitarioService,
    private toastr:ToastrService,
    // nlpr ini
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    // nlpr fin
    ) {
      
  }
  
  // nlpr ini
  // Función para manejar la navegación
  navigate(page: string) {
    // console.log(`Navegando a: ${page}`);
    // Aquí puedes agregar lógica para navegar a diferentes rutas
  }
  
  // Función para alternar el menú general (inicio, fotografías, etc.)
  toggleMenu() {
    // console.log('Toggling menu', this.isMenuCollapsed);
    this.isMenuCollapsed = !this.isMenuCollapsed;
    // console.log('Menu isMenuCollapsed:', this.isMenuCollapsed);
  }

  // Función para alternar el submenú de "Cultural"
  toggleCulturalMenu() {
    // console.log('Toggling submenu cultural', this.isCulturalMenuOpen);
    this.isCulturalMenuOpen = !this.isCulturalMenuOpen;
  }
  
  togglePortadaMenu() {
    // console.log('Toggling submenu portada', this.isPortadasMenuOpen);
    this.isPortadasMenuOpen = !this.isPortadasMenuOpen;
  }
  // nlpr fin

  obtenerSesion(){
    return this.usuarioService.existeSesionUsuario();
  }

  obtenerCantidadCarrito(){
    // Primero actualizar la cantidad desde el servicio
    this.carritoService.obtenerCantidadCarrito();
    const cantidadActual = Number(this.carritoService.cantidadCarrito);

    // Si la cantidad cambió, actualizar el flag para recargar el carrito
    if (cantidadActual !== this.cantidadCarritoAnterior) {
      // console.log('🔄 Header-detail: Cantidad carrito cambió de', this.cantidadCarritoAnterior, 'a', cantidadActual);
      this.cantidadCarritoAnterior = cantidadActual;
      this.cantidadCarrito = cantidadActual;
      this.actualizarCarrito();
      // console.log('🔄 Header-detail: flagActualizar incrementado a', this.flagActualizar);
    } else {
      this.cantidadCarrito = cantidadActual;
    }
  }
 
  actualizarCarrito(){
    this.flagActualizar = this.flagActualizar + 1;

  }

  onItemEliminado(){
    // Actualizar la cantidad del carrito cuando se elimina un item desde el header
    this.obtenerCantidadCarrito();
    this.actualizarCarrito();
  }

  // Método para construir URLs amigables
  private buildFriendlyUrl(idCategoria: string, idSubCategoria?: string): string {
    const catSlug = this.CAT_ID_TO_SLUG[idCategoria];
    if (!catSlug) {
      return '/consultas/' + this.generaNss(); // Fallback para categorías no mapeadas
    }

    let url = '/' + catSlug;

    if (idSubCategoria && this.SUB_ID_TO_SLUG[idCategoria]?.[idSubCategoria]) {
      const subSlug = this.SUB_ID_TO_SLUG[idCategoria][idSubCategoria];
      url += '/' + subSlug;
    }

    // console.log('🔗 Header construyendo URL amigable:', { idCategoria, idSubCategoria, url });
    return url;
  }

  buscarConsulta(idCategoria,idSubCategoria){
    // console.log("buscarConsulta:idCategoria:"+idCategoria+"-idSubCategoria:"+idSubCategoria);
    this.novedadesService.idCategoria=idCategoria;
    this.novedadesService.idSubCategoria=idSubCategoria;
    this.txtBusqueda="";
    // daet ini
    if (idCategoria==1 || idCategoria==2 || idCategoria==3){
      this.isFechaEnable=false;
    }else{
      this.isFechaEnable=true;
    }
    this.txtFechaIni="";
    this.txtFechaFin="";
    this.utilitarioService.fecIni="";
    this.utilitarioService.fecFin="";
    this.utilitarioService.idCategoria=idCategoria;
    // daet fin

    // 🔗 Navegar usando URLs amigables
    const friendlyUrl = this.buildFriendlyUrl(idCategoria.toString(), idSubCategoria ? idSubCategoria.toString() : '');
    // console.log('🔗 Header navegando a:', friendlyUrl);
    this.router.navigateByUrl(friendlyUrl);
  }

  generaNss() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < charactersLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  obtenerMenu(){
    this.menuResponse= new MenuResponse();
    this.maestraService.obtenerMenu().subscribe(data=>{
      this.menuResponse = data;
      this.menuFlag=true;

    })
  }

  buscar(){
    // console.log(this.txtBusqueda);

    // Limpiar espacios y convertir a minúsculas
    const cleanSearch = this.txtBusqueda.trim().toLowerCase();

    // Si no hay texto de búsqueda, no hacer nada
    if (!cleanSearch) {
      return;
    }

    this.utilitarioService.busqueda = cleanSearch;

    // Las búsquedas se realizan en /consultas que busca en TODAS las categorías
    // (fotografías, portadas, hemeroteca)
    const baseRoute = '/consultas';

    // Navegar con query params para realizar la búsqueda
    this.router.navigate([baseRoute], {
      queryParams: { q: cleanSearch, page: 1 }
    });
  }

  // daet1
  visibilidad(selector) {
      // console.log("visibilidad"+selector);
      switch(selector){
        case "#subMenuFotografia":{
          this.utilitarioService.seccion="F";
          var ele1:any = document.querySelector("#subMenuFotografia"); 
          ele1.style.display = "block";
          var ele2:any = document.querySelector("#subMenuPortada"); 
          ele2.style.display = "none";
          var ele3:any = document.querySelector("#subMenuHemeroteca");
          ele3.style.display = "none";
          break;
        }
        case "#subMenuPortada":{
          this.utilitarioService.seccion="P";
          var ele1:any = document.querySelector("#subMenuFotografia"); 
          ele1.style.display = "none";
          var ele2:any = document.querySelector("#subMenuPortada"); 
          ele2.style.display = "block";
          var ele3:any = document.querySelector("#subMenuHemeroteca");
          ele3.style.display = "none";
          break;
        }
        case "#subMenuHemeroteca":{
          this.utilitarioService.seccion="H";
          var ele1:any = document.querySelector("#subMenuFotografia"); 
          ele1.style.display = "none";
          var ele2:any = document.querySelector("#subMenuPortada"); 
          ele2.style.display = "none";
          var ele3:any = document.querySelector("#subMenuHemeroteca");
          ele3.style.display = "block";
          break;
        }
      }
      /*
      var elemento = document.querySelector(selector);         
      if (elemento != null) {
        let display = elemento.style.display;
        if(display=="none"||display===""){
        elemento.style.display = "block";
        }
        if(display==="block"){
          elemento.style.display = "none";
        }
      }*/
  }
  
  ngOnInit(): void {
    // nlpr ini
    this.selectedOption = this.activatedRoute.snapshot.paramMap.get('idCate');
    // console.log("newwwwww"+this.selectedOption);
    // nlpr fi
    this.obtenerMenu();
    this.carritoService.obtenerCantidadCarrito();

    // Inicializar cantidad anterior
    this.cantidadCarritoAnterior = Number(this.carritoService.cantidadCarrito);

    // Suscribirse a cambios en el carrito
    this.carritoService.carritoActualizado$.subscribe(cantidad => {
      // console.log('🔔 Header-detail: Notificación de cambio en carrito. Nueva cantidad:', cantidad);
      if (cantidad !== this.cantidadCarritoAnterior) {
        // console.log('🔄 Header-detail: Cantidad carrito cambió de', this.cantidadCarritoAnterior, 'a', cantidad);
        this.cantidadCarritoAnterior = cantidad;
        this.cantidadCarrito = cantidad;
        this.actualizarCarrito();
        // console.log('🔄 Header-detail: flagActualizar incrementado a', this.flagActualizar);
      }
    });

    // Mantener el setInterval como respaldo
    setInterval(() => {
      this.obtenerCantidadCarrito()
    }, 100);
  }

  // daet ini
  //ngAfterViewInit () {
    //this.onOpenOrdenDetalle();
  //} 
  // daet fin

  ngAfterViewInit(): void {
    // Esto se ejecutará después de que la vista se haya inicializado completamente
    this.visibilidad("#subMenuFotografia");
  }

  // daet ini
  onBuscar(evento:String){
    this.utilitarioService.loading = true;
    if (evento=="load"){
      //formato date para la consulta
      let dateCurrent = new Date();
      this.fechaIniLoad = "01/01/" + dateCurrent.getFullYear();
      this.fechaFinLoad = "31/12/" + dateCurrent.getFullYear();
    }else{
      // console.log("Buscar:"+this.txtBusqueda);

      // Limpiar búsqueda
      const cleanSearch = this.txtBusqueda ? this.txtBusqueda.trim().toLowerCase() : '';

      this.utilitarioService.busqueda = cleanSearch;
      this.utilitarioService.fecIni = this.txtFechaIni;
      this.utilitarioService.fecFin = this.txtFechaFin;

      // Las búsquedas se realizan en /consultas que busca en TODAS las categorías
      // (fotografías, portadas, hemeroteca)
      const baseRoute = '/consultas';

      // Construir query params
      const queryParams: any = { page: 1 };

      if (cleanSearch) {
        queryParams.q = cleanSearch;
      }

      if (this.txtFechaIni && this.txtFechaFin) {
        // Validación de fechas para Hemeroteca
        if (this.utilitarioService.idCategoria === '3') {
          let fecIniRanIni = new Date(1825, 1, 1);
          let fecIniRanFin = new Date(1951, 12, 1);
          let yi = Number(this.utilitarioService.fecIni.substring(0, 4));
          let mi = Number(this.utilitarioService.fecIni.substring(5, 7));
          let di = Number(this.utilitarioService.fecIni.substring(8, 12));
          let yf = Number(this.utilitarioService.fecFin.substring(0, 4));
          let mf = Number(this.utilitarioService.fecFin.substring(5, 7));
          let df = Number(this.utilitarioService.fecFin.substring(8, 12));

          let fecIniInpIni = new Date(yi, mi, di);
          let fecIniInpFin = new Date(yf, mf, df);

          let validaFecha = true;
          if (fecIniInpIni.getTime() < fecIniRanIni.getTime()) {
            validaFecha = false;
          }
          if (fecIniInpFin.getTime() > fecIniRanFin.getTime()) {
            validaFecha = false;
          }

          if (!validaFecha) {
            this.showWarning("Rango de fechas no permitido para Hemeroteca");
            this.utilitarioService.loading = false;
            return;
          }
        }

        queryParams.fi = this.txtFechaIni;
        queryParams.ff = this.txtFechaFin;
      }

      // Navegar con query params
      this.router.navigate([baseRoute], { queryParams });
    }
    this.utilitarioService.loading = false;
  }
  // daet fin

  // daet ini
  onOpenOrdenDetalle() {
    //console.log("orderAdminBean",orderAdminBean);
    this.modalRefCambioEstado = this.modalService.show(
      ModalHomeComponent,
      //DetalleOrdenComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          idOrden: 1,          
          nroOrden:1,
          total: 1,
          date: '01/01/2021',
          clientName: 'a',
          stateName: 'a',         
        }
      }
    );
  }
  onClosemodal(){
    this.modalRefCambioEstado.hide();
  }
  // daet fin

  showWarning(mensaje) {
    this.toastr.warning(mensaje);
  }

  // daet1
  hideModal() {
    this.modallogin.hide();
  }

  closeItem() {
    // console.log("hi1");
    // console.log("hic"+document.getElementById('modallogin').style.display);
    document.getElementById('modallogin').style.display="none";
    document.getElementById('modallogin1').click();
    // console.log("hi2");
    //ngDropdown.close();
  }
  
  // nlpr ini
  selectOption(option: string) {
    // console.log("menu:"+option);
    this.selectedOption = option; 
    if (option === 'fotografias') {
      this.isCulturalMenuOpen = false;  // Asegura que el submenú de Cultural se oculte al seleccionar otra opción
    }
    if (option === 'portadas') {
      this.isPortadasMenuOpen = false;  // Asegura que el submenú de Cultural se oculte al seleccionar otra opción
    }
  }
  /*
  openCalendar() {
    // Aquí puedes agregar la lógica para abrir el calendario si lo deseas
    // console.log('Icono de calendario clickeado');
  }
  
  // Este método puede ser útil para manejar el evento cuando el calendario se cierra
  onCalendarClosed() {
    // console.log('Calendario cerrado');
  }*/

    selectedDateRange: { begin: Date | null, end: Date | null } = { begin: null, end: null };

   
  // Método que se llama cuando el usuario selecciona un rango de fechas
  onDateChange(event: any) {
    // Este evento es disparado cada vez que el rango cambia
    // console.log('Fecha de cambio detectada:', event);
    // Aquí, `event.value` contendría el rango de fechas seleccionado
    this.selectedDateRange = event.value;
    // console.log('Fechas seleccionadas:', this.selectedDateRange);

    
  }

    clearDates() {
      // console.log('Rango de fechas limpiar');
      // console.log('xxx'+this.selectedDateRange);
      // console.log('xxx'+this.selectedDateRange.begin);
      // console.log('xxx'+this.selectedDateRange.end);
      this.selectedDateRange = { begin: null, end: null };
      // console.log('Rango de fechas limpiado');
    }
  
  dateChanged(_type: "start" | "end", _event): void {
    // console.log("_type:"+_type);
    if (_type=="end" && this.selectedDateRange.begin!=null && this.selectedDateRange.end!=null){
      const formattedBeginDate = this.datePipe.transform(this.selectedDateRange.begin, 'yyyy-MM-dd') ?? '';
      const formattedEndDate = this.datePipe.transform(this.selectedDateRange.end, 'yyyy-MM-dd')?? '';
      this.txtFechaIni=formattedBeginDate;
      this.txtFechaFin=formattedEndDate;
      // console.log(formattedBeginDate + "-"+formattedEndDate);
      // console.log(_type, _event);
      this.onBuscar("");
    }  
    
    
  }

  
  
  // nlpr fin

}
